import React, {Fragment, useState} from "react";
import {Grid, TextField, InputAdornment, Typography} from "@material-ui/core";
import {fileUpload} from "../../../dataSource/fileManager";
import {Alert} from "../../Alert/Alert";
import ConfirmDialog from "../../Dialog/ConfirmDialog";
import NormalDialog from "../../Dialog/NormalDialog";
import PilStageTwoUploadDetails from "./pilSection/pilStageTwoUploadDetails";
import LockScreenLoading from "../../LockScreenLoading/LockScreenLoading";
import FullScreenDialog from "../../Dialog/FullScreenDialog";
import {deletePilAttachment, insertPilAttachment} from "../../../dataSource/pil";
import FilePreview from "../../FilePreview/FilePreview";
import Legend from "../../Legend/Legend";
import PilStageTwoFileDropzone from "../../FileDropzone/PilStageTwoFileDropzone";
import PilFileZoneContentSupportDoc from "./pilSection/pilFileZoneContentSupportDoc";
import {useDispatch} from "react-redux";

const ProjectInformationStageTwoForm = (props) => {

    const fileTypes = [
        {
            name: "ochart",
            description: "1. O-Chart and Manpower Schedule"
        },
        {
            name: "tender",
            description: "2. Tender and Design Information Schedule"
        },
        {
            name: "tempwork",
            description: "3. Temporary work Schedule"
        },
        {
            name: "plant",
            description: "4. Plant Schedule"
        },
        {
            name: "others",
            description: "5. Others (e.g. Construction Plan, Program and Method Presentation, etc.)"
        },
    ]

    const {pilDetails, setPilDetails, stage, setUpdateFlag,uploadable,lock} = props;
    const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false);
    const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
    const [progressTitle, setProgressTitle] = useState("");
    const [stageTwoFiles, setStageTwoFiles] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmDialogData, setConfirmDialogData] = useState({
        dialogTitle: "",
        dialogContent: "",
        confirmAction: "",
        cancelAction: "",
    });
    const [filePreviewProperty, SetFilePreviewProperty] = useState(null);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertData, setAlertData] = useState({
        type: "",
        title: "",
        content: "",
    });
    const dispatch = useDispatch();
    const [stagetwoUploadDialogOpen, setStagetwoUploadDialogOpen] =
        useState(false);
    const buildAlert = (data) => {
        setAlertData({
            type: data.type,
            title: data.title,
            content: data.content,
        });
        setAlertOpen(true);
    };
    const stageTwofileUploadAction = async (stageTwoFiles, acceptedFilesPool, fileType) => {
        let uploadedFilesPool = [];
        if (acceptedFilesPool.length === 0) {
            return;
        }
        await Promise.all(
            acceptedFilesPool.map(async (file, index) => {
                try {
                    await fileUpload(file).then(async (res) => {
                        let data = res.data[0];
                        uploadedFilesPool = [...uploadedFilesPool, data];
                        await buildFileRecord(fileType, data)
                    });
                    await setStageTwoFiles([...stageTwoFiles, ...uploadedFilesPool]);
                    // setStagetwoUploadDialogOpen(true);
                } catch (error) {
                    buildAlert({
                        // Alert Type: success, info, warning, error
                        type: "error",
                        title: "Error Alert",
                        content: `${error.message}`,
                    });
                }
            })
        );
    };
    const buildFileRecord = async (type, data) => {
        try {
            const details = {...pilDetails};
            details.uploadFiles = [...details.uploadFiles, data];
            data.stage = stage;
            data.type = type;
            await insertPilAttachment(pilDetails.general.pil_seq, data).then(
                () => {
                    setUpdateFlag((prev) => !prev);
                    dispatch({
                        type: "HANDLE_PIL_VALUE",
                        data: {...pilDetails, details},
                    });
                    buildAlert({
                        type: "success",
                        title: "Success Alert",
                        content:
                            "The Project Information List File has been uploaded successfully",
                    });
                }
            );
        } catch (err) {
            buildAlert({
                type: "error",
                title: "Error Alert",
                content: `Error:${err}`,
            });
        }
    };
    const filePreviewDialogHandleOpen = () => {
        setFilePreviewDialogOpen(true);
    };
    const filePreviewDialogHandleClose = () => {
        setFilePreviewDialogOpen(false);
    };
    const confirmDialogHandleOpen = (data) => {
        setConfirmDialogData({
            dialogTitle: data.dialogTitle,
            dialogContent: data.dialogContent,
            confirmAction: data.confirmAction,
            cancelAction: data.cancelAction,
        });

        setConfirmDialogOpen(true);
    };

    const confirmDialogHandleClose = () => {
        setConfirmDialogOpen(false);
    };
    const stagetwoDialogHandleClose = () => {
        setStageTwoFiles([]);
        setStagetwoUploadDialogOpen(false);
    };
    const removeFileConfirmAction = (fileRecord) => {
        confirmDialogHandleOpen({
            dialogTitle: "Delete File",
            dialogContent:
                "Are you sure to delete the uploaded Project Information List?",
            confirmAction: () => {
                deleteFileConfirm(fileRecord);
            },
            cancelAction: confirmDialogHandleClose,
        });
    };
    const deleteFileConfirm = async (fileRecord) => {
        confirmDialogHandleClose();
        try {
            await deletePilAttachment(fileRecord.atth_seq).then((res) => {
                setUpdateFlag((prev) => !prev);
                buildAlert({
                    // Alert Type: success, info, warning, error
                    type: "success",
                    title: "Success Alert",
                    content:
                        "The Project Information List File has been deleted successfully",
                });
            });
        } catch (err) {
            buildAlert({
                // Alert Type: success, info, warning, error
                type: "error",
                title: "Error Alert",
                content: `Error:${err}`,
            });
        }
    };
    const viewFileAction = (fileCat, fileSeq, filename) => {
        SetFilePreviewProperty({
            fileCategory: fileCat,
            fileSequence: fileSeq,
            filename: filename,
        });
        filePreviewDialogHandleOpen();
    };
    // const handleBudget = (e) => {
    //     let data = {...pilDetails};
    //     data["details"]["pre_budget"] = e.target.value;
    //     setPilDetails({...pilDetails, ...data});
    // };
    return (
        <Fragment>
            <LockScreenLoading
                open={lockScreenLoadingOpen}
                circleSize={200}
                progressTitle={progressTitle}
            />
            <FullScreenDialog
                open={filePreviewDialogOpen}
                dialogTitle={"Project Information List Preview"}
                formContent={<FilePreview filePreviewProperty={filePreviewProperty}/>}
                button={[]}
                handleClose={filePreviewDialogHandleClose}
            />
            <Alert
                open={alertOpen}
                alertType={alertData.type}
                alertTitle={alertData.title}
                alertContent={alertData.content}
                handleClose={() => setAlertOpen(false)}
            />
            <NormalDialog
                open={stagetwoUploadDialogOpen}
                dialogTitle={`Select Attachment(s) Type`}
                button={[]}
                size={"lg"}
                height={700}
                formContent={
                    <PilStageTwoUploadDetails
                        stageTwoFiles={stageTwoFiles}
                        setStageTwoFiles={setStageTwoFiles}
                        stagetwoDialogHandleClose={stagetwoDialogHandleClose}
                        pilDetails={pilDetails}
                        setUpdateFlag={setUpdateFlag}
                        buildAlert={buildAlert}
                        setLockScreenLoadingOpen={setLockScreenLoadingOpen}
                    />
                }
                handleClose={stagetwoDialogHandleClose}
            />
            <ConfirmDialog
                open={confirmDialogOpen}
                dialogTitle={confirmDialogData.dialogTitle}
                dialogContent={confirmDialogData.dialogContent}
                confirmAction={confirmDialogData.confirmAction}
                cancelAction={confirmDialogData.cancelAction}
            />
            {fileTypes.map(type =>
                <Grid container spacing={1}
                      key={type.name}
                >
                    <Typography variant="subtitle2" style={
                        {
                            margin: "20px 0 5px 5px",
                            color: "#808080",
                            fontSize: "15px"
                        }
                    }>{type.description}</Typography>
                    <Grid item xs={12}>
                        <Legend
                            id="attachment"
                            normalTitleColor={"gray"}
                            normalBorderColor={"#becedf"}
                        >
                            <PilStageTwoFileDropzone
                                key={"pil_attachment"}
                                title={""}
                                fileType={type.name}
                                disabled={lock}
                                fileArray={stageTwoFiles}
                                fileUploadAction={stageTwofileUploadAction}
                                fileRemoveAction={removeFileConfirmAction}
                                viewFileAction={viewFileAction}
                                uploadable={uploadable}
                                DropzoneContent={PilFileZoneContentSupportDoc}
                            />
                        </Legend>
                    </Grid>
                    {/*
             <Grid item xs={6}>
                  <TextField
                    value={pilDetails.details.pre_budget}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          Preliminart Budget Estimate HK$
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          per sq. ft. of GFA
                        </InputAdornment>
                      ),
                    }}
                    fullWidth
                    id={"pre_budget"}
                    name={"pre_budget"}
                    size="small"
                    variant="outlined"
                    onChange={handleBudget}
                  />
                </Grid>
            */}
                </Grid>
            )}

        </Fragment>
    );
};

export default ProjectInformationStageTwoForm;
